// extracted by mini-css-extract-plugin
module.exports = {"userButton":"UserButton_userButton__1x_J3","menu":"UserButton_menu__2Vf-i","item":"UserButton_item__2jSTI","title":"UserButton_title__3gdZz"};